<script>
import { assignSiteInspector } from '@/utils/site-inspection'
import { getSiteInspectorDropdown } from '@/utils/site-inspector'

export default {

    inject: ['setLoading'],

    data() {
        return {
            id: null,
            inspection_number: '',
            site_inspector_id: '',
            inspectors: [],
            errors: {}
        }
    },

    methods: {

        async open(row) {
            this.reset()
            this.id = row.id
            this.inspection_number = row.inspection_number
            await this.loadDropdown()
        },

        async loadDropdown() {
            try {
                const res = await getSiteInspectorDropdown()
                this.inspectors = res?.data?.data || []
            } catch (e) {
                this.$swalToast(e.message, 'error')
            }
        },

        async save() {
            this.setLoading(true)

            try {
                const res = await assignSiteInspector(this.id, {
                    site_inspector_id: this.site_inspector_id
                })

                this.$swalToast(res.data.message)
                this.$emit('updated')
                this.$closeModal('assign_inspector_modal')

            } catch (error) {
                if (error.type === 'validation') {
                    this.errors = error.errors
                } else {
                    this.$swalToast(error.message, 'error')
                }
            } finally {
                this.setLoading(false)
            }
        },

        reset() {
            this.id = null
            this.inspection_number = ''
            this.site_inspector_id = ''
            this.inspectors = []
            this.errors = {}
        }
    }
}
</script>

<template>
    <div class="modal fade" id="assign_inspector_modal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-header">
                    <h5>Assign Site Inspector</h5>
                    <button class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <form @submit.prevent="save">
                    <div class="modal-body">

                        <!-- Inspection Number (read-only) -->
                        <div class="mb-3">
                            <label class="form-label">Inspection #</label>
                            <input type="text" class="form-control" :value="inspection_number" disabled />
                        </div>

                        <!-- Select Inspector -->
                        <div class="mb-3">
                            <label class="form-label">Select Site Inspector</label>

                            <vue-select
                                :options="inspectors"
                                :get-option-label="row => row.user?.name"
                                :reduce="row => row.id"
                                v-model="site_inspector_id"
                                placeholder="Select Site Inspector"
                            />

                            <div v-if="errors.site_inspector_id"
                                style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                                <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.site_inspector_id[0] }}
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary">Assign</button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>